<script>
  import { _ } from './services/i18n'
</script>

<h2 id="whyUs">{$_('whyus.title')}</h2>
<div class="descContainer">
  <p class="desc">{$_('whyus.desc')}</p>
  <p class="desc">{$_('whyus.desc1')}</p>
</div>
<section class="container">
  <div class="another box">
    <h3>{$_('whyus.another_title')}<i class="fa-solid fa-clock" /></h3>
    <div class="first-col">
      <p>{$_('whyus.another1')}</p>
      <p>{$_('whyus.another2')}</p>
      <p>{$_('whyus.another3')}</p>
      <p>{$_('whyus.another4')}</p>
      <p>{$_('whyus.another5')}</p>
    </div>
    <div class="second-col">
      <p>{$_('whyus.another6')}</p>
      <p>{$_('whyus.another7')}</p>
      <p>{$_('whyus.another8')}</p>
      <p>{$_('whyus.another9')}</p>
      <p>{$_('whyus.another10')}</p>
    </div>
  </div>
  <div class="experience box">
    <h3>{$_('whyus.experience')}<i class="fa-solid fa-briefcase" /></h3>
    <p>{$_('whyus.experience_title')}</p>
  </div>
  <div class="quality box">
    <h3>{$_('whyus.quality')}<i class="fa-solid fa-scale-balanced" /></h3>
    <p>{$_('whyus.quality_title')}</p>
  </div>
  <div class="price box">
    <h3>{$_('whyus.price')}<i class="fa-solid fa-money-bill" /></h3>
    <p>{$_('whyus.price_title')}</p>
  </div>
  <div class="time box">
    <h3>{$_('whyus.terms')}<i class="fa-solid fa-clock" /></h3>
    <p>{$_('whyus.terms_title')}</p>
  </div>
</section>

<style>
  .container {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 4rem 1rem;
  }
  .descContainer {
    text-align: center;
    margin-top: 2rem;
  }
  .desc {
    color: var(--textColor);
  }
  h2 {
    padding: 5rem 0 0 2rem;
    font-size: 2rem;
    font-weight: 500;
    text-align: center;
  }
  h3 {
    font-size: 1.5rem;
    padding-bottom: 0.75rem;
    display: flex;
    align-items: center;
    gap: 5px;
    color: var(--mainWhite);
  }
  i {
    padding-left: 0.25rem;
    color: var(--mainWhite);
  }
  p {
    color: var(--mainWhite);
  }

  .box {
    background-color: var(--mainWhite);
    background-color: rgb(20, 24, 36);
    border-top: 5px solid var(--primaryColor);
    padding: 1rem;
    margin: 1rem;
    min-height: 306px;
    flex-basis: 31%;
  }

  @media (max-width: 1400px) {
    .box {
      flex-basis: 45%;
    }
  }
  @media (max-width: 768px) {
    .container {
      padding-bottom: 0;
      padding-top: 2rem;
    }
    .desc {
      padding: 0 1rem;
    }
    h2 {
      padding: 0 1rem;
    }
    .box {
      flex-basis: 100%;
      padding: 20px 10px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 1rem 0;
    }
  }
</style>
